var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var BrandInfo = /** @class */ (function (_super) {
    __extends(BrandInfo, _super);
    function BrandInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrandInfo.prototype.render = function () {
        return (React.createElement("div", { className: "sv-brand-info" },
            React.createElement("a", { className: "sv-brand-info__logo", href: "https://surveyjs.io/?utm_source=built-in_links&utm_medium=online_survey_tool&utm_campaign=landing_page" },
                React.createElement("img", { src: "https://surveyjs.io/Content/Images/poweredby.svg" })),
            React.createElement("div", { className: "sv-brand-info__text" },
                "Try and see how easy it is to ",
                React.createElement("a", { href: "https://surveyjs.io/create-survey?utm_source=built-in_links&utm_medium=online_survey_tool&utm_campaign=create_survey" }, "create a survey")),
            React.createElement("div", { className: "sv-brand-info__terms" },
                React.createElement("a", { href: "https://surveyjs.io/TermsOfUse" }, "Terms of Use & Privacy Statement"))));
    };
    return BrandInfo;
}(React.Component));
export { BrandInfo };
